import { render, staticRenderFns } from "./TopInfluencers.vue?vue&type=template&id=1c51e11c&scoped=true&"
import script from "./TopInfluencers.vue?vue&type=script&lang=js&"
export * from "./TopInfluencers.vue?vue&type=script&lang=js&"
import style0 from "./TopInfluencers.vue?vue&type=style&index=0&id=1c51e11c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c51e11c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib'
installComponents(component, {VRow})
